import React, { useState } from 'react';

const SobreNosotros = () => {
  const [mostrarHistoriaCompleta, setMostrarHistoriaCompleta] = useState(false);

  const sectionStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '60px',
    maxWidth: '1100px',
    margin: '0 auto 50px auto',
    flexWrap: 'wrap',
    paddingTop: '10px',
  };

  const textStyle = {
    flex: 1,
    fontFamily: 'Georgia, serif',
    fontSize: '15px',
    lineHeight: '1.8',
    textAlign: 'justify',
    color: '#222',
    minWidth: '300px',
    maxWidth: '550px',
  };

  const imageWrapperStyle = {
    position: 'relative',
    width: '420px',
    height: 'auto',
    boxShadow: '0 0 10px rgba(0,0,0,0.15)',
    overflow: 'hidden',
  };

  const imageOverlayStyle = {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-20px',
    width: '110%',
    height: '50%',
    backgroundColor: '#e1e1e1',
    zIndex: 0,
  };

  const imageStyle = {
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
    position: 'relative',
    zIndex: 1,
  };

  const headingStyle = {
    fontSize: '28px',
    color: '#000',
    fontWeight: 'bold',
    marginBottom: '18px',
    fontFamily: 'Georgia, serif',
  };

  const botonStyle = {
    marginTop: '20px',
    backgroundColor: '#0C8193',
    color: '#fff',
    border: 'none',
    padding: '10px 18px',
    borderRadius: '2px',
    cursor: 'pointer',
    fontFamily: 'Georgia, serif',
    fontSize: '14px',
  };

  const styles = {
    footer: {
      background: 'linear-gradient(to right, #1786a0, #0f2d45)',
      color: '#fff',
      padding: '20px 8',
      fontSize: '13px',
      width: '100%',
      margin: 0,
    },
    footerContent: {
      maxWidth: '700px',
      margin: '0 auto',
      textAlign: 'center',
      fontFamily: "'Montserrat', sans-serif",
    },
    footerTextCenter: {
      margin: '10px 0',
      lineHeight: '1.6',
    },
    footerLink: {
      color: '#ffffff',
      textDecoration: 'underline',
    },
    contactRow: {
      display: 'flex',
      justifyContent: 'space-around',
      flexWrap: 'wrap',
      gap: '10px',
      margin: '20px 0',
    },
    socialIconsClean: {
      display: 'flex',
      justifyContent: 'center',
      gap: '25px',
      margin: '20px 0 15px 0',
    },
    socialIcon: {
      width: '30px',
      height: '30px',
    },
    tiktokIcon: {
      width: '30px',
      height: '30px',
      filter: 'brightness(5)',
    },
  };

  const ImagenConFondo = ({ src, alt }) => {
    const isDirector = alt === 'Director General';
    return (
      <div
        style={{
          ...imageWrapperStyle,
          height: isDirector ? '370px' : 'auto',
        }}
      >
        <div style={imageOverlayStyle}></div>
        <img
          src={src}
          alt={alt}
          style={{
            ...imageStyle,
            height: isDirector ? '130%' : 'auto',
            objectFit: 'cover',
          }}
        />
      </div>
    );
  };

  return (
    <div
      style={{
        padding: '20px',
        fontFamily: 'Georgia, serif',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
        paddingBottom: 0,
      }}
    >
      <h1
        style={{
          textAlign: 'center',
          fontSize: '95px',
          marginBottom: '40px',
          fontWeight: 'bold',
          color: '#0C8193',
        }}
      ></h1>

      {/* Reseña Histórica */}
      <div style={sectionStyle}>
        <div style={textStyle}>
          <h2 style={headingStyle}>Reseña Histórica</h2>
          <p>
            Nuestra historia inicia con un enfoque en la mecanografía y ha evolucionado hasta convertirse en un grupo educativo con presencia nacional.
          </p>
          {!mostrarHistoriaCompleta ? (
            <button style={botonStyle} onClick={() => setMostrarHistoriaCompleta(true)}>
              Conocer más
            </button>
          ) : (
            <>
              <p>Nuestra escuela inició sus actividades en los años 80’s bajo la denominación CCPM en el Distrito Federal con 7 escuelas solo con curso de mecanografía fundada por Felipe Aguirre Meza, originario de Durango. 5 años después se fusiona con Cástulo Aguirre Meza y Guillermo Aguirre Meza, formando Grupo Pionero ya trabajando con informática.</p>
              <p>En 1987 se abre en Zamora Michoacán la primera escuela denominada Computación Empresarial por Juan Rubio Aguirre, Jesús Rubio Aguirre, Efrén Loza y Julio Aguirre.</p>
              <p>En 1993 los hermanos Rubio Aguirre se separan y abren CCEIS en Moroleón, Gto.</p>
              <p>En 1994 Manuel Fernando Rubio Aguirre abre CEIS en Acámbaro y posteriormente en San Juan del Río.</p>
              <p>En 2000 se apertura CEIS en Tula de Allende y después en Pachuca.</p>
              <p>En 2009 se funda el Instituto Profesional de Belleza Evolusion en Tula y más tarde en Pachuca y Acámbaro.</p>
              <p>En 2011 se inicia Preparatoria Abierta en Acámbaro con el nombre Tomás G. Mazaryk.</p>
              <p>En 2012 se integra plantel Tula Preparatoria Abierta.</p>
              <p>En 2013 abre un nuevo Instituto en Maravatío Michoacán con Preparatoria y Belleza.</p>
              <p>En 2017 abre Royal Emporio en Acámbaro.</p>
              <p>En 2019 abre Instituto Royal School con carrera de barbería.</p>
              <p>En 2023 abre la escuela de barbería Don Porfirio en Tula.</p>
              <p>Actualmente somos 7 Institutos a nivel nacional con más de 60 empleados, dirigidos por el Lic. Manuel Fernando Rubio Aguirre.</p>
              <button style={botonStyle} onClick={() => setMostrarHistoriaCompleta(false)}>
                Ver menos
              </button>
            </>
          )}
        </div>
        <ImagenConFondo src="/reseña.jpg" alt="Reseña Histórica" />
      </div>

      {/* Misión */}
      <div style={{ ...sectionStyle, flexDirection: 'row-reverse' }}>
        <div style={textStyle}>
          <h2 style={headingStyle}>Misión</h2>
          <p>
            Somos una institución de educación privada que se caracteriza por su compromiso en la búsqueda permanente
            de la excelencia académica, dedicada a la formación de profesionales, capaces de interactuar en el entorno
            social conjugando conocimientos, técnicas, aptitudes y valores que se traduzcan en una actuación competitiva
            orientada a ofrecer opciones diferentes, útiles y realistas en el campo laboral.
          </p>
        </div>
        <ImagenConFondo src="/VidaI.png" alt="Misión" />
      </div>

      {/* Visión */}
      <div style={sectionStyle}>
        <div style={textStyle}>
          <h2 style={headingStyle}>Visión</h2>
          <p>
            Grupo Impulsor será reconocido por contar con una propuesta educativa de alta calidad, consolidándonos, así
            como la mejor institución de formación para el trabajo y el desarrollo humano, expertos en educar mediante
            estrategias educativas con base en el enfoque por competencias, actuando siempre con valores y responsabilidad social.
          </p>
        </div>
        <ImagenConFondo src="/Vision.jpeg" alt="Visión" />
      </div>

      {/* Director General */}
      <div style={{ ...sectionStyle, flexDirection: 'row-reverse' }}>
        <div style={textStyle}>
          <h2 style={headingStyle}>Director General</h2>
          <p>
            Nuestro director general lidera con una visión transformadora y compromiso hacia la excelencia educativa,
            promoviendo un ambiente de innovación, ética y formación integral.
          </p>
        </div>
        <ImagenConFondo src="/director.png" alt="Director General" />
      </div>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerContent}>
          <p style={styles.footerTextCenter}>
            <strong>Instituto Grupo Impulsor Educativo</strong><br />
            <a href="https://maps.google.com/?q=Calzada Melchor Ocampo 204" target="_blank" rel="noopener noreferrer" style={styles.footerLink}>
              Calzada Melchor Ocampo 204
            </a>
          </p>

          <div style={styles.contactRow}>
            <p>Teléfono: 773-134-56-39 / 773-732-76-04</p>
            <p>Correo: grupoimpulsoreducativotula@gmail.com</p>
          </div>

          <div style={styles.socialIconsClean}>
            
            <a href="https://www.facebook.com/share/19RskfDHie/" target="_blank" rel="noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/733/733547.png" alt="Facebook" style={styles.socialIcon} />
            </a>
            {/* Instagram */}
            <a href="https://www.instagram.com/grupo_impulsor_educativo" target="_blank" rel="noreferrer">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
                alt="Instagram"
                style={styles.socialIcon}
              />
            </a>
            <a href="https://www.tiktok.com/@grupo_impulsor_educativo?is_from_webapp=1&sender_device=pc" target="_blank" rel="noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/3046/3046122.png" alt="TikTok" style={styles.tiktokIcon} />
            </a>
          </div>

          <p style={styles.footerTextCenter}>
            Todos los derechos reservados a grupoimpulsoreducativo 2025
          </p>
        </div>
      </footer>
    </div>
  );
};

export default SobreNosotros;
